import type { FoodOption } from "./types.ts";

// ── Fruits ──

export const FRUITS: FoodOption[] = [
  { id: "0", name: "Arándanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arándanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  { id: "1", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
];

// ── Carbs ──
// IMPORTANT: Preserve original item positions (indices) for backward compatibility
// with saved plans. New items must be appended at the end.

export const BREAKFAST_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Avena cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Avena en hojuelas cruda (USDA)",
    per100g: { calories: 389, protein: 16.9, carbs: 66.3, fat: 6.9 },
    perPortion: { calories: 97.3, protein: 4.2, carbs: 16.6, fat: 1.7 },
  }},
  /* 1 */ { id: "1", name: "Pan de molde", portion: "1 und", nutrition: {
    sourceName: "Pan de Molde Blanco Bimbo",
    per100g: { calories: 259, protein: 8.9, carbs: 44.1, fat: 4.2 },
    perPortion: { calories: 72.5, protein: 2.5, carbs: 12.3, fat: 1.2 },
  }},
  /* 2 */ { id: "2", name: "Pan pita", portion: "1 und", nutrition: {
    sourceName: "Pan Pita (USDA)",
    per100g: { calories: 275, protein: 9.1, carbs: 55.7, fat: 1.2 },
    perPortion: { calories: 123.8, protein: 4.1, carbs: 25.1, fat: 0.5 },
  }},
  /* 3 */ { id: "3", name: "Rapidita", portion: "1 und", nutrition: {
    sourceName: "Tortillas Rapiditas Clásicas Bimbo",
    per100g: { calories: 284, protein: 7.7, carbs: 48.1, fat: 6.7 },
    perPortion: { calories: 73.8, protein: 2.0, carbs: 12.5, fat: 1.7 },
  }},
  /* 4 */ { id: "4", name: "Tostada", portion: "1 und", nutrition: {
    sourceName: "Pan Tostado Clásico Bimbo",
    per100g: { calories: 400, protein: 10.5, carbs: 73, fat: 7.7 },
    perPortion: { calories: 64.0, protein: 1.7, carbs: 11.7, fat: 1.2 },
  }},
  /* 5 */ { id: "5", name: "Galletas Salmas", portion: "1 paquete (3 und)", nutrition: {
    sourceName: "Salmas Sanissimo",
    per100g: { calories: 350, protein: 8.3, carbs: 70, fat: 3.3 },
    perPortion: { calories: 63.0, protein: 1.5, carbs: 12.6, fat: 0.6 },
  }},
  /* 6 — was "Fruta" placeholder, kept for backward compat */
  { id: "6", name: "Fruta (ver opciones de fruta)", portion: "1 opción" },
  // ── New options (appended) ──
  { id: "7", name: "Arándanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arándanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  { id: "8", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
];

/** Pre-workout / snack carbs — same as breakfast but WITHOUT Galletas Salmas */
export const SNACK_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Avena cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Avena en hojuelas cruda (USDA)",
    per100g: { calories: 389, protein: 16.9, carbs: 66.3, fat: 6.9 },
    perPortion: { calories: 97.3, protein: 4.2, carbs: 16.6, fat: 1.7 },
  }},
  /* 1 */ { id: "1", name: "Pan de molde", portion: "1 und", nutrition: {
    sourceName: "Pan de Molde Blanco Bimbo",
    per100g: { calories: 259, protein: 8.9, carbs: 44.1, fat: 4.2 },
    perPortion: { calories: 72.5, protein: 2.5, carbs: 12.3, fat: 1.2 },
  }},
  /* 2 */ { id: "2", name: "Pan pita", portion: "1 und", nutrition: {
    sourceName: "Pan Pita (USDA)",
    per100g: { calories: 275, protein: 9.1, carbs: 55.7, fat: 1.2 },
    perPortion: { calories: 123.8, protein: 4.1, carbs: 25.1, fat: 0.5 },
  }},
  /* 3 */ { id: "3", name: "Rapidita", portion: "1 und", nutrition: {
    sourceName: "Tortillas Rapiditas Clásicas Bimbo",
    per100g: { calories: 284, protein: 7.7, carbs: 48.1, fat: 6.7 },
    perPortion: { calories: 73.8, protein: 2.0, carbs: 12.5, fat: 1.7 },
  }},
  /* 4 */ { id: "4", name: "Tostada", portion: "1 und", nutrition: {
    sourceName: "Pan Tostado Clásico Bimbo",
    per100g: { calories: 400, protein: 10.5, carbs: 73, fat: 7.7 },
    perPortion: { calories: 64.0, protein: 1.7, carbs: 11.7, fat: 1.2 },
  }},
  /* 5 — was "Fruta" placeholder, kept for backward compat */
  { id: "5", name: "Fruta (ver opciones de fruta)", portion: "1 opción" },
  // ── New options (appended) ──
  { id: "6", name: "Arándanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arándanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  { id: "7", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
];

export const MAIN_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Arroz blanco", portion: "50 g", grams: 50, nutrition: {
    sourceName: "Arroz blanco cocido grano largo (USDA #168878)",
    per100g: { calories: 130, protein: 2.7, carbs: 28.2, fat: 0.3 },
    perPortion: { calories: 65, protein: 1.4, carbs: 14.1, fat: 0.2 },
  }},
  /* 1 */ { id: "1", name: "Arroz integral", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Arroz integral cocido grano largo (USDA #169704)",
    per100g: { calories: 123, protein: 2.7, carbs: 25.6, fat: 1.0 },
    perPortion: { calories: 86.1, protein: 1.9, carbs: 17.9, fat: 0.7 },
  }},
  /* 2 — was "Menestras", now "Lentejas" (same lentil data, more specific name) */
  { id: "2", name: "Lentejas", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Lentejas cocidas hervidas (USDA #172421)",
    per100g: { calories: 116, protein: 9.0, carbs: 20.1, fat: 0.4 },
    perPortion: { calories: 92.8, protein: 7.2, carbs: 16.1, fat: 0.3 },
  }},
  /* 3 */ { id: "3", name: "Papa", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Papa hervida sin piel (USDA #170440)",
    per100g: { calories: 86, protein: 1.7, carbs: 20.0, fat: 0.1 },
    perPortion: { calories: 60.2, protein: 1.2, carbs: 14.0, fat: 0.1 },
  }},
  /* 4 */ { id: "4", name: "Yuca", portion: "45 g", grams: 45, nutrition: {
    sourceName: "Yuca cocida hervida (USDA estimado)",
    per100g: { calories: 155, protein: 1.4, carbs: 37.5, fat: 0.3 },
    perPortion: { calories: 69.8, protein: 0.6, carbs: 16.9, fat: 0.1 },
  }},
  /* 5 */ { id: "5", name: "Camote", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Camote hervido sin piel (USDA #168484)",
    per100g: { calories: 76, protein: 1.4, carbs: 17.7, fat: 0.1 },
    perPortion: { calories: 60.8, protein: 1.1, carbs: 14.2, fat: 0.1 },
  }},
  /* 6 */ { id: "6", name: "Choclo", portion: "63 g", grams: 63, nutrition: {
    sourceName: "Maíz dulce amarillo cocido hervido (USDA #169999)",
    per100g: { calories: 96, protein: 3.4, carbs: 21.0, fat: 1.5 },
    perPortion: { calories: 60.5, protein: 2.1, carbs: 13.2, fat: 0.9 },
  }},
  /* 7 */ { id: "7", name: "Fideos blancos", portion: "48 g", grams: 48, nutrition: {
    sourceName: "Pasta cocida enriquecida (USDA #169737)",
    per100g: { calories: 158, protein: 5.8, carbs: 30.9, fat: 0.9 },
    perPortion: { calories: 75.8, protein: 2.8, carbs: 14.8, fat: 0.4 },
  }},
  /* 8 */ { id: "8", name: "Fideos integrales", portion: "53 g", grams: 53, nutrition: {
    sourceName: "Pasta integral cocida (USDA #168910)",
    per100g: { calories: 149, protein: 6.0, carbs: 30.1, fat: 1.7 },
    perPortion: { calories: 79.0, protein: 3.2, carbs: 16.0, fat: 0.9 },
  }},
  /* 9 */ { id: "9", name: "Guiso (locro, olluquito, etc.)", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Guiso peruano promedio cocido (estimado)",
    per100g: { calories: 100, protein: 5.0, carbs: 15.0, fat: 2.0 },
    perPortion: { calories: 80.0, protein: 4.0, carbs: 12.0, fat: 1.6 },
  }},
  // ── New options (appended) ──
  { id: "10", name: "Arvejita partida", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Arvejas partidas cocidas hervidas (USDA #175216)",
    per100g: { calories: 118, protein: 8.34, carbs: 21.1, fat: 0.4 },
    perPortion: { calories: 94.4, protein: 6.7, carbs: 16.9, fat: 0.3 },
  }},
  { id: "11", name: "Frejol", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Frijoles pintos cocidos hervidos (USDA #175194)",
    per100g: { calories: 143, protein: 9.0, carbs: 26.2, fat: 0.65 },
    perPortion: { calories: 114.4, protein: 7.2, carbs: 21.0, fat: 0.5 },
  }},
  { id: "12", name: "Garbanzo", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Garbanzos cocidos hervidos (USDA #173757)",
    per100g: { calories: 164, protein: 8.86, carbs: 27.4, fat: 2.59 },
    perPortion: { calories: 131.2, protein: 7.1, carbs: 21.9, fat: 2.1 },
  }},
  { id: "13", name: "Quinua", portion: "70 g cocido", grams: 70, nutrition: {
    sourceName: "Quinua cocida (USDA)",
    per100g: { calories: 120, protein: 4.4, carbs: 21.3, fat: 1.9 },
    perPortion: { calories: 84.0, protein: 3.1, carbs: 14.9, fat: 1.3 },
  }},
];

// DINNER_CARBS: Flattened (no spread) to preserve stable indices.
// Original indices 0-6 = BREAKFAST_CARBS items, 7+ = dinner-specific items.
export const DINNER_CARBS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Avena cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Avena en hojuelas cruda (USDA)",
    per100g: { calories: 389, protein: 16.9, carbs: 66.3, fat: 6.9 },
    perPortion: { calories: 97.3, protein: 4.2, carbs: 16.6, fat: 1.7 },
  }},
  /* 1 */ { id: "1", name: "Pan de molde", portion: "1 und", nutrition: {
    sourceName: "Pan de Molde Blanco Bimbo",
    per100g: { calories: 259, protein: 8.9, carbs: 44.1, fat: 4.2 },
    perPortion: { calories: 72.5, protein: 2.5, carbs: 12.3, fat: 1.2 },
  }},
  /* 2 */ { id: "2", name: "Pan pita", portion: "1 und", nutrition: {
    sourceName: "Pan Pita (USDA)",
    per100g: { calories: 275, protein: 9.1, carbs: 55.7, fat: 1.2 },
    perPortion: { calories: 123.8, protein: 4.1, carbs: 25.1, fat: 0.5 },
  }},
  /* 3 */ { id: "3", name: "Rapidita", portion: "1 und", nutrition: {
    sourceName: "Tortillas Rapiditas Clásicas Bimbo",
    per100g: { calories: 284, protein: 7.7, carbs: 48.1, fat: 6.7 },
    perPortion: { calories: 73.8, protein: 2.0, carbs: 12.5, fat: 1.7 },
  }},
  /* 4 */ { id: "4", name: "Tostada", portion: "1 und", nutrition: {
    sourceName: "Pan Tostado Clásico Bimbo",
    per100g: { calories: 400, protein: 10.5, carbs: 73, fat: 7.7 },
    perPortion: { calories: 64.0, protein: 1.7, carbs: 11.7, fat: 1.2 },
  }},
  /* 5 */ { id: "5", name: "Galletas Salmas", portion: "1 paquete (3 und)", nutrition: {
    sourceName: "Salmas Sanissimo",
    per100g: { calories: 350, protein: 8.3, carbs: 70, fat: 3.3 },
    perPortion: { calories: 63.0, protein: 1.5, carbs: 12.6, fat: 0.6 },
  }},
  /* 6 — was "Fruta" placeholder */
  { id: "6", name: "Fruta (ver opciones de fruta)", portion: "1 opción" },
  /* 7 */ { id: "7", name: "Quinua cruda (cocinar)", portion: "25 g", grams: 25, nutrition: {
    sourceName: "Quinua cruda (USDA)",
    per100g: { calories: 368, protein: 14.1, carbs: 64.2, fat: 6.1 },
    perPortion: { calories: 92.0, protein: 3.5, carbs: 16.1, fat: 1.5 },
  }},
  /* 8 */ { id: "8", name: "Arroz blanco", portion: "50 g", grams: 50, nutrition: {
    sourceName: "Arroz blanco cocido grano largo (USDA #168878)",
    per100g: { calories: 130, protein: 2.7, carbs: 28.2, fat: 0.3 },
    perPortion: { calories: 65, protein: 1.4, carbs: 14.1, fat: 0.2 },
  }},
  /* 9 */ { id: "9", name: "Arroz integral", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Arroz integral cocido grano largo (USDA #169704)",
    per100g: { calories: 123, protein: 2.7, carbs: 25.6, fat: 1.0 },
    perPortion: { calories: 86.1, protein: 1.9, carbs: 17.9, fat: 0.7 },
  }},
  /* 10 — was "Menestras", now "Lentejas" */
  { id: "10", name: "Lentejas", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Lentejas cocidas hervidas (USDA #172421)",
    per100g: { calories: 116, protein: 9.0, carbs: 20.1, fat: 0.4 },
    perPortion: { calories: 92.8, protein: 7.2, carbs: 16.1, fat: 0.3 },
  }},
  /* 11 */ { id: "11", name: "Papa", portion: "70 g", grams: 70, nutrition: {
    sourceName: "Papa hervida sin piel (USDA #170440)",
    per100g: { calories: 86, protein: 1.7, carbs: 20.0, fat: 0.1 },
    perPortion: { calories: 60.2, protein: 1.2, carbs: 14.0, fat: 0.1 },
  }},
  /* 12 */ { id: "12", name: "Yuca", portion: "45 g", grams: 45, nutrition: {
    sourceName: "Yuca cocida hervida (USDA estimado)",
    per100g: { calories: 155, protein: 1.4, carbs: 37.5, fat: 0.3 },
    perPortion: { calories: 69.8, protein: 0.6, carbs: 16.9, fat: 0.1 },
  }},
  /* 13 */ { id: "13", name: "Choclo", portion: "63 g", grams: 63, nutrition: {
    sourceName: "Maíz dulce amarillo cocido hervido (USDA #169999)",
    per100g: { calories: 96, protein: 3.4, carbs: 21.0, fat: 1.5 },
    perPortion: { calories: 60.5, protein: 2.1, carbs: 13.2, fat: 0.9 },
  }},
  /* 14 */ { id: "14", name: "Fideos blancos", portion: "48 g", grams: 48, nutrition: {
    sourceName: "Pasta cocida enriquecida (USDA #169737)",
    per100g: { calories: 158, protein: 5.8, carbs: 30.9, fat: 0.9 },
    perPortion: { calories: 75.8, protein: 2.8, carbs: 14.8, fat: 0.4 },
  }},
  /* 15 */ { id: "15", name: "Fideos integrales", portion: "53 g", grams: 53, nutrition: {
    sourceName: "Pasta integral cocida (USDA #168910)",
    per100g: { calories: 149, protein: 6.0, carbs: 30.1, fat: 1.7 },
    perPortion: { calories: 79.0, protein: 3.2, carbs: 16.0, fat: 0.9 },
  }},
  /* 16 */ { id: "16", name: "Camote", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Camote hervido sin piel (USDA #168484)",
    per100g: { calories: 76, protein: 1.4, carbs: 17.7, fat: 0.1 },
    perPortion: { calories: 60.8, protein: 1.1, carbs: 14.2, fat: 0.1 },
  }},
  // ── New options (appended) ──
  { id: "17", name: "Arándanos", portion: "120 g", grams: 120, nutrition: {
    sourceName: "Arándanos frescos (USDA)",
    per100g: { calories: 57, protein: 0.7, carbs: 14.5, fat: 0.3 },
    perPortion: { calories: 68.4, protein: 0.8, carbs: 17.4, fat: 0.4 },
  }},
  { id: "18", name: "Fresa", portion: "180 g", grams: 180, nutrition: {
    sourceName: "Fresas frescas (USDA)",
    per100g: { calories: 32, protein: 0.7, carbs: 7.7, fat: 0.3 },
    perPortion: { calories: 57.6, protein: 1.3, carbs: 13.9, fat: 0.5 },
  }},
  { id: "19", name: "Arvejita partida", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Arvejas partidas cocidas hervidas (USDA #175216)",
    per100g: { calories: 118, protein: 8.34, carbs: 21.1, fat: 0.4 },
    perPortion: { calories: 94.4, protein: 6.7, carbs: 16.9, fat: 0.3 },
  }},
  { id: "20", name: "Frejol", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Frijoles pintos cocidos hervidos (USDA #175194)",
    per100g: { calories: 143, protein: 9.0, carbs: 26.2, fat: 0.65 },
    perPortion: { calories: 114.4, protein: 7.2, carbs: 21.0, fat: 0.5 },
  }},
  { id: "21", name: "Garbanzo", portion: "80 g cocido", grams: 80, nutrition: {
    sourceName: "Garbanzos cocidos hervidos (USDA #173757)",
    per100g: { calories: 164, protein: 8.86, carbs: 27.4, fat: 2.59 },
    perPortion: { calories: 131.2, protein: 7.1, carbs: 21.9, fat: 2.1 },
  }},
  { id: "22", name: "Quinua", portion: "70 g cocido", grams: 70, nutrition: {
    sourceName: "Quinua cocida (USDA)",
    per100g: { calories: 120, protein: 4.4, carbs: 21.3, fat: 1.9 },
    perPortion: { calories: 84.0, protein: 3.1, carbs: 14.9, fat: 1.3 },
  }},
];

// ── Proteins ──

export const FULL_PROTEINS: FoodOption[] = [
  { id: "0", name: "Huevo entero", portion: "1 und", nutrition: {
    sourceName: "Huevo de gallina entero crudo (USDA)",
    per100g: { calories: 155, protein: 12.6, carbs: 1.1, fat: 11.3 },
    perPortion: { calories: 77.5, protein: 6.3, carbs: 0.6, fat: 5.7 },
  }},
  { id: "1", name: "Claras de huevo", portion: "2 und", nutrition: {
    sourceName: "Clara de huevo cruda (USDA)",
    per100g: { calories: 52, protein: 10.9, carbs: 0.7, fat: 0.2 },
    perPortion: { calories: 34.3, protein: 7.2, carbs: 0.5, fat: 0.1 },
  }},
  { id: "2", name: "Pollo", portion: "40 g crudo", grams: 40, cookedGrams: 30, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 48.0, protein: 9.0, carbs: 0, fat: 1.0 },
  }},
  { id: "3", name: "Atún en conserva", portion: "30 g", grams: 30, nutrition: {
    sourceName: "Atún enlatado en agua (USDA)",
    per100g: { calories: 116, protein: 25.5, carbs: 0, fat: 0.8 },
    perPortion: { calories: 34.8, protein: 7.7, carbs: 0, fat: 0.2 },
  }},
  { id: "4", name: "Yogurt griego Vakimu", portion: "150 g", grams: 150, nutrition: {
    sourceName: "Yogurt Griego Original Vakimu",
    per100g: { calories: 52, protein: 4.6, carbs: 1.4, fat: 3.1 },
    perPortion: { calories: 78.0, protein: 6.9, carbs: 2.1, fat: 4.7 },
  }},
  { id: "5", name: "Queso fresco", portion: "30 g", grams: 30, nutrition: {
    sourceName: "Queso fresco de vaca (USDA)",
    per100g: { calories: 268, protein: 17.5, carbs: 3.0, fat: 21.0 },
    perPortion: { calories: 80.4, protein: 5.3, carbs: 0.9, fat: 6.3 },
  }},
  { id: "6", name: "Vakimu Pro", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Vakimu +PRO",
    per100g: { calories: 69, protein: 8.8, carbs: 5, fat: 1.9 },
    perPortion: { calories: 55.2, protein: 7.0, carbs: 4.0, fat: 1.5 },
  }},
];

// Dinner proteins extend FULL_PROTEINS with meat/fish options David eats at
// CENA only. Per-option portion matches Romina's dinner (35 g crudo / 25 g
// cocido) because Y/X = 1 for their shared dinner pollo (40 g crudo each).
// Indices 0-6 match FULL_PROTEINS so saved dinner plans remain stable.
export const DINNER_PROTEINS: FoodOption[] = [
  { id: "0", name: "Huevo entero", portion: "1 und", nutrition: {
    sourceName: "Huevo de gallina entero crudo (USDA)",
    per100g: { calories: 155, protein: 12.6, carbs: 1.1, fat: 11.3 },
    perPortion: { calories: 77.5, protein: 6.3, carbs: 0.6, fat: 5.7 },
  }},
  { id: "1", name: "Claras de huevo", portion: "2 und", nutrition: {
    sourceName: "Clara de huevo cruda (USDA)",
    per100g: { calories: 52, protein: 10.9, carbs: 0.7, fat: 0.2 },
    perPortion: { calories: 34.3, protein: 7.2, carbs: 0.5, fat: 0.1 },
  }},
  { id: "2", name: "Pollo", portion: "40 g crudo", grams: 40, cookedGrams: 30, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 48.0, protein: 9.0, carbs: 0, fat: 1.0 },
  }},
  { id: "3", name: "Atún en conserva", portion: "30 g", grams: 30, nutrition: {
    sourceName: "Atún enlatado en agua (USDA)",
    per100g: { calories: 116, protein: 25.5, carbs: 0, fat: 0.8 },
    perPortion: { calories: 34.8, protein: 7.7, carbs: 0, fat: 0.2 },
  }},
  { id: "4", name: "Yogurt griego Vakimu", portion: "150 g", grams: 150, nutrition: {
    sourceName: "Yogurt Griego Original Vakimu",
    per100g: { calories: 52, protein: 4.6, carbs: 1.4, fat: 3.1 },
    perPortion: { calories: 78.0, protein: 6.9, carbs: 2.1, fat: 4.7 },
  }},
  { id: "5", name: "Queso fresco", portion: "30 g", grams: 30, nutrition: {
    sourceName: "Queso fresco de vaca (USDA)",
    per100g: { calories: 268, protein: 17.5, carbs: 3.0, fat: 21.0 },
    perPortion: { calories: 80.4, protein: 5.3, carbs: 0.9, fat: 6.3 },
  }},
  { id: "6", name: "Vakimu Pro", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Vakimu +PRO",
    per100g: { calories: 69, protein: 8.8, carbs: 5, fat: 1.9 },
    perPortion: { calories: 55.2, protein: 7.0, carbs: 4.0, fat: 1.5 },
  }},
  // ── Dinner-only additions ──
  { id: "7", name: "Carne de res", portion: "35 g crudo", grams: 35, cookedGrams: 25, nutrition: {
    sourceName: "Carne de res magra cruda (USDA)",
    per100g: { calories: 143, protein: 21.4, carbs: 0, fat: 5.9 },
    perPortion: { calories: 50.1, protein: 7.5, carbs: 0, fat: 2.1 },
  }},
  { id: "8", name: "Pescado", portion: "35 g crudo", grams: 35, cookedGrams: 25, nutrition: {
    sourceName: "Tilapia cruda (USDA)",
    per100g: { calories: 96, protein: 20.1, carbs: 0, fat: 1.7 },
    perPortion: { calories: 33.6, protein: 7.0, carbs: 0, fat: 0.6 },
  }},
  { id: "9", name: "Carne molida", portion: "35 g crudo", grams: 35, cookedGrams: 25, nutrition: {
    sourceName: "Carne molida 90/10 cruda (USDA #174036)",
    per100g: { calories: 176, protein: 20.0, carbs: 0, fat: 10.0 },
    perPortion: { calories: 61.6, protein: 7.0, carbs: 0, fat: 3.5 },
  }},
];

export const SNACK_PROTEINS: FoodOption[] = [
  { id: "0", name: "Huevo entero", portion: "1 und", nutrition: {
    sourceName: "Huevo de gallina entero crudo (USDA)",
    per100g: { calories: 155, protein: 12.6, carbs: 1.1, fat: 11.3 },
    perPortion: { calories: 77.5, protein: 6.3, carbs: 0.6, fat: 5.7 },
  }},
  { id: "1", name: "Claras de huevo", portion: "2 und", nutrition: {
    sourceName: "Clara de huevo cruda (USDA)",
    per100g: { calories: 52, protein: 10.9, carbs: 0.7, fat: 0.2 },
    perPortion: { calories: 34.3, protein: 7.2, carbs: 0.5, fat: 0.1 },
  }},
  { id: "2", name: "Pollo", portion: "40 g crudo", grams: 40, cookedGrams: 30, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 48.0, protein: 9.0, carbs: 0, fat: 1.0 },
  }},
  { id: "3", name: "Yogurt griego Vakimu", portion: "150 g", grams: 150, nutrition: {
    sourceName: "Yogurt Griego Original Vakimu",
    per100g: { calories: 52, protein: 4.6, carbs: 1.4, fat: 3.1 },
    perPortion: { calories: 78.0, protein: 6.9, carbs: 2.1, fat: 4.7 },
  }},
  { id: "4", name: "Vakimu Pro", portion: "80 g", grams: 80, nutrition: {
    sourceName: "Vakimu +PRO",
    per100g: { calories: 69, protein: 8.8, carbs: 5, fat: 1.9 },
    perPortion: { calories: 55.2, protein: 7.0, carbs: 4.0, fat: 1.5 },
  }},
];

// ── Lunch proteins (larger portions, vary by regimen) ──

export const GYM_LUNCH_PROTEINS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Pollo", portion: "360 g crudo", grams: 360, cookedGrams: 270, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 432.0, protein: 81.0, carbs: 0, fat: 9.4 },
  }},
  /* 1 */ { id: "1", name: "Pescado", portion: "315 g crudo", grams: 315, cookedGrams: 225, nutrition: {
    sourceName: "Tilapia cruda (USDA)",
    per100g: { calories: 96, protein: 20.1, carbs: 0, fat: 1.7 },
    perPortion: { calories: 302.4, protein: 63.3, carbs: 0, fat: 5.4 },
  }},
  /* 2 */ { id: "2", name: "Carne de res", portion: "315 g crudo", grams: 315, cookedGrams: 225, nutrition: {
    sourceName: "Carne de res magra cruda (USDA)",
    per100g: { calories: 143, protein: 21.4, carbs: 0, fat: 5.9 },
    perPortion: { calories: 450.5, protein: 67.4, carbs: 0, fat: 18.6 },
  }},
  // ── New ──
  { id: "3", name: "Carne molida", portion: "315 g crudo", grams: 315, cookedGrams: 225, nutrition: {
    sourceName: "Carne molida 90/10 cruda (USDA #174036)",
    per100g: { calories: 176, protein: 20.0, carbs: 0, fat: 10.0 },
    perPortion: { calories: 554.4, protein: 63.0, carbs: 0, fat: 31.5 },
  }},
];

export const CARDIO_REST_LUNCH_PROTEINS: FoodOption[] = [
  /* 0 */ { id: "0", name: "Pollo", portion: "320 g crudo", grams: 320, cookedGrams: 240, nutrition: {
    sourceName: "Pechuga de pollo cruda sin piel (USDA)",
    per100g: { calories: 120, protein: 22.5, carbs: 0, fat: 2.6 },
    perPortion: { calories: 384.0, protein: 72.0, carbs: 0, fat: 8.3 },
  }},
  /* 1 */ { id: "1", name: "Pescado", portion: "280 g crudo", grams: 280, cookedGrams: 200, nutrition: {
    sourceName: "Tilapia cruda (USDA)",
    per100g: { calories: 96, protein: 20.1, carbs: 0, fat: 1.7 },
    perPortion: { calories: 268.8, protein: 56.3, carbs: 0, fat: 4.8 },
  }},
  /* 2 */ { id: "2", name: "Carne de res", portion: "280 g crudo", grams: 280, cookedGrams: 200, nutrition: {
    sourceName: "Carne de res magra cruda (USDA)",
    per100g: { calories: 143, protein: 21.4, carbs: 0, fat: 5.9 },
    perPortion: { calories: 400.4, protein: 59.9, carbs: 0, fat: 16.5 },
  }},
  /* 3 — Atún stays at original index 3 */ { id: "3", name: "Atún en conserva", portion: "240 g", grams: 240, nutrition: {
    sourceName: "Atún enlatado en agua (USDA)",
    per100g: { calories: 116, protein: 25.5, carbs: 0, fat: 0.8 },
    perPortion: { calories: 278.4, protein: 61.2, carbs: 0, fat: 1.9 },
  }},
  // ── New (appended after original items) ──
  { id: "4", name: "Carne molida", portion: "280 g crudo", grams: 280, cookedGrams: 200, nutrition: {
    sourceName: "Carne molida 90/10 cruda (USDA #174036)",
    per100g: { calories: 176, protein: 20.0, carbs: 0, fat: 10.0 },
    perPortion: { calories: 492.8, protein: 56.0, carbs: 0, fat: 28.0 },
  }},
];

// ── Fats ──

export const FATS: FoodOption[] = [
  { id: "0", name: "Aceite de oliva", portion: "1 cdta", nutrition: {
    sourceName: "Aceite de oliva extra virgen (USDA)",
    per100g: { calories: 884, protein: 0, carbs: 0, fat: 100 },
    perPortion: { calories: 39.8, protein: 0, carbs: 0, fat: 4.5 },
  }},
  { id: "1", name: "Palta", portion: "40 g", grams: 40, nutrition: {
    sourceName: "Aguacate/Palta (USDA)",
    per100g: { calories: 160, protein: 2.0, carbs: 8.5, fat: 14.7 },
    perPortion: { calories: 64.0, protein: 0.8, carbs: 3.4, fat: 5.9 },
  }},
  { id: "2", name: "Aceitunas", portion: "6 und", nutrition: {
    sourceName: "Aceitunas verdes (USDA)",
    per100g: { calories: 145, protein: 1.0, carbs: 3.8, fat: 15.3 },
    perPortion: { calories: 26.1, protein: 0.2, carbs: 0.7, fat: 2.8 },
  }},
  { id: "3", name: "Frutos secos", portion: "10 g", grams: 10, nutrition: {
    sourceName: "Frutos secos mixtos (USDA)",
    per100g: { calories: 607, protein: 20.0, carbs: 21.0, fat: 54.0 },
    perPortion: { calories: 60.7, protein: 2.0, carbs: 2.1, fat: 5.4 },
  }},
];

// ── Vegetables ──

export const VEGETABLES_FRESH: FoodOption[] = [
  { id: "0", name: "Verduras frescas", portion: "2 tz", nutrition: {
    sourceName: "Ensalada mixta (lechuga, tomate, pepino)",
    per100g: { calories: 20, protein: 1.5, carbs: 3.5, fat: 0.2 },
    perPortion: { calories: 24.0, protein: 1.8, carbs: 4.2, fat: 0.2 },
  }},
  { id: "1", name: "Verduras cocidas", portion: "1 tz", nutrition: {
    sourceName: "Verduras mixtas cocidas (USDA)",
    per100g: { calories: 35, protein: 2.0, carbs: 7.0, fat: 0.3 },
    perPortion: { calories: 52.5, protein: 3.0, carbs: 10.5, fat: 0.5 },
  }},
];

export const VEGETABLES_SMALL: FoodOption[] = [
  { id: "0", name: "Verduras frescas", portion: "1 tz", nutrition: {
    sourceName: "Ensalada mixta (lechuga, tomate, pepino)",
    per100g: { calories: 20, protein: 1.5, carbs: 3.5, fat: 0.2 },
    perPortion: { calories: 12.0, protein: 0.9, carbs: 2.1, fat: 0.1 },
  }},
  { id: "1", name: "Verduras cocidas", portion: "½ tz", nutrition: {
    sourceName: "Verduras mixtas cocidas (USDA)",
    per100g: { calories: 35, protein: 2.0, carbs: 7.0, fat: 0.3 },
    perPortion: { calories: 26.3, protein: 1.5, carbs: 5.3, fat: 0.2 },
  }},
];

export const EGG_YOLK_NOTE = "En el caso de consumir huevo, consumir máximo 2 yemas";
export const GELATIN_NOTE = "Puedes consumir gelatina con normalidad en su versión light (0% azúcar)";
